import Button from "@/Components/Button/Button";
import Modal, { ModalProps } from "@/Components/Modal/Modal";
import Table from "@/Components/Table/Table";
import { TableColumn } from "@/Components/Table/types";
import { useModalMeta } from "@/shared/atoms/useModal";
import {
  formatDate,
  formatPrice,
  reportToOverview,
} from "@/shared/utils/helpers";
import { CourierReport } from "@/shared/v2/queries/interfacesV2";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router-dom";

const DelivererOverviewModal = ({ onExit, ...props }: ModalProps) => {
  const [meta] = useModalMeta();
  const { t } = useTranslation();
  const history = useHistory();
  const report = meta.report as CourierReport;
  const data = reportToOverview(report);
  const columns = useMemo<
    TableColumn<{
      description: string;
      value: string;
      date: string;
      item_id: number;
      type: string;
    }>[]
  >(
    () => [
      {
        Header: t("description"),
        accessor: "description",
        id: "description",
        Cell: (row) => (
          <div className="flex gap-4">
            <div>
              {t(row.type === "order" ? "order_modal.order" : row.description)}
            </div>
            {row.type === "order" && (
              <Button
                onClick={() => history.push(`/order/${row.item_id}`)}
                size="small"
              >
                #{row.description}
              </Button>
            )}
          </div>
        ),
      },
      {
        Header: "",
        accessor: "value",
        id: "value",
        Cell: (row) => formatPrice(row.value),
      },
    ],
    [t]
  );

  return (
    <Modal onExit={onExit} width={{ _: "95%", md: "50rem" }} {...props}>
      <h3 className="mb-[1rem]">
        {t("deliverers.modalTitle", {
          name: report.name,
          date: formatDate(report.start_date_and_time),
        })}
      </h3>
      <div>
        <Table
          id="description"
          disableFilter
          disableAction
          tableName="deliverers"
          data={data ?? []}
          columns={columns}
          disableSort
          disablePagination
        />
      </div>
    </Modal>
  );
};

export default DelivererOverviewModal;
